'use strict';

require('core-js/es6/object');
require('core-js/es6/function');
require('core-js/es6/array');
require('core-js/es6/string');
require('core-js/es6/number');
require('core-js/es6/date');
require('core-js/es6/promise');
require('core-js/es6/symbol');
require('core-js/es7/object');
require('core-js/es7/string');
require('core-js/es7/array');
require('isomorphic-fetch');



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/polyfill.js
// module id = 2328
// module chunks = 64